var _g, _g2, _path, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 872,
    height: 570,
    viewBox: "0 0 872 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_196_3526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872 285C872 442.401 820.96 570 758 570C695.04 570 644 442.401 644 285C644 127.599 695.04 -2.23101e-06 758 -4.9831e-06C820.96 -7.73519e-06 872 127.599 872 285Z",
    fill: "url(#paint0_linear_196_3526)",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_196_3526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M783 285.34C783 410.897 742.219 512.681 691.913 512.681C641.607 512.681 600.826 410.897 600.826 285.34C600.826 159.783 641.607 57.9994 691.913 57.9994C742.219 57.9994 783 159.783 783 285.34Z",
    fill: "url(#paint1_linear_196_3526)",
    fillOpacity: 0.16
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.626 285.34C510.626 406.437 548.555 505.396 596.378 512.281C594.612 512.544 592.829 512.677 591.044 512.681C540.73 512.681 499.957 410.902 499.957 285.34C499.957 159.779 540.73 57.9995 591.044 57.9995C592.829 58.0031 594.612 58.1366 596.378 58.399C548.555 65.2846 510.626 164.338 510.626 285.34Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M538.31 431.768C521.343 396.776 510.58 344.394 510.58 285.832C510.58 227.269 521.343 174.911 538.31 139.919L538.31 95.0808L589.212 95.0808C631.911 96.0208 666.433 181.044 666.433 285.808C666.433 390.572 631.911 475.619 589.212 476.559L538.31 476.559L538.31 431.768Z",
    fill: "url(#paint2_linear_196_3526)",
    fillOpacity: 0.84
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_196_3526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.026 285.833C616.026 391.194 581.232 476.607 538.311 476.607C495.39 476.607 460.596 391.194 460.596 285.833C460.596 180.471 495.39 95.0581 538.311 95.0581C581.232 95.0581 616.026 180.471 616.026 285.833Z",
    fill: "url(#paint3_linear_196_3526)",
    fillOpacity: 0.16
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M599.412 285.338C599.412 378.188 571.425 453.458 536.901 453.458C502.377 453.458 474.391 378.188 474.391 285.338C474.391 192.488 502.377 117.218 536.901 117.218C571.425 117.218 599.412 192.488 599.412 285.338Z",
    fill: "#FCFAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M510.558 368.787C500.923 348.929 494.813 319.178 494.813 285.925C494.813 252.673 500.923 222.945 510.558 203.087L510.558 177.542L539.439 177.542C563.692 178.083 583.291 226.352 583.291 285.831C583.291 345.31 563.692 393.603 539.439 394.144L510.558 394.144L510.558 368.787Z",
    fill: "url(#paint4_linear_196_3526)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M581.974 285.831C581.974 226.352 562.399 178.083 538.147 177.542L539.439 177.542C563.691 178.083 583.29 226.352 583.29 285.831C583.29 345.31 563.691 393.603 539.439 394.144L538.1 394.144C562.399 393.603 581.974 345.287 581.974 285.831Z",
    fill: "black"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M554.69 285.833C554.69 345.652 534.931 394.145 510.557 394.145C486.183 394.145 466.424 345.652 466.424 285.833C466.424 226.014 486.183 177.521 510.557 177.521C534.931 177.521 554.69 226.014 554.69 285.833Z",
    fill: "url(#paint5_linear_196_3526)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M545.242 285.554C545.242 338.274 529.344 381.012 509.733 381.012C490.122 381.012 474.225 338.274 474.225 285.554C474.225 232.834 490.122 190.096 509.733 190.096C529.344 190.096 545.242 232.834 545.242 285.554Z",
    fill: "#FCFAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M553.069 285.835C553.069 226.685 533.752 178.627 509.734 177.57C510.016 177.57 510.275 177.57 510.557 177.57C534.927 177.57 554.69 226.051 554.69 285.858C554.69 345.666 534.927 394.171 510.557 394.171C510.275 394.171 510.016 394.171 509.734 394.171C533.752 393.066 553.069 345.008 553.069 285.835Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.46893e-05 117.372L537.487 117.372C572.009 117.372 599.998 192.573 599.998 285.493C599.998 378.412 572.009 453.425 537.487 453.425L0 453.425L-1.46893e-05 117.372Z",
    fill: "url(#paint6_linear_196_3526)",
    fillOpacity: 0.08
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_196_3526",
    x: 621.895,
    y: -22.1053,
    width: 272.211,
    height: 614.211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_196_3526",
    x: 578.721,
    y: 35.8941,
    width: 226.384,
    height: 498.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_196_3526",
    x: 438.49,
    y: 72.9528,
    width: 199.64,
    height: 425.759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_3526",
    x1: 846.279,
    y1: 588.049,
    x2: 503.037,
    y2: 98.9188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_3526",
    x1: 762.449,
    y1: 527.078,
    x2: 488.803,
    y2: 136.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_196_3526",
    x1: 669.698,
    y1: 285.319,
    x2: 453.193,
    y2: 238.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_196_3526",
    x1: 598.492,
    y1: 488.689,
    x2: 370.186,
    y2: 157.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_196_3526",
    x1: 539.04,
    y1: 177.542,
    x2: 539.04,
    y2: 394.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_196_3526",
    x1: 510.557,
    y1: 177.544,
    x2: 510.557,
    y2: 394.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F3FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_196_3526",
    x1: 508.817,
    y1: 452.54,
    x2: 0,
    y2: 452.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge3);
export default __webpack_public_path__ + "static/media/bridge-3.4d6ada184b21d8c40b291993df3f459d.svg";
export { ForwardRef as ReactComponent };